import React from 'react';

const Error = () => {
    
    window.onscroll = () => {};
    
    return (
        <div>
            
        </div>
    );
}

export default Error;
